/* eslint-disable import/no-duplicates */
/* eslint-disable camelcase */

import doorbell_graham_cracker from '$src/assets/img/device_doorbell_mini.png';
import doorbell, { default as doorbell_v2 } from '$src/assets/img/device_doorbell_gen_2.png';
import doorbell_v3, { default as doorbell_v4, default as doorbell_v5, default as df_doorbell_clownfish } from '$src/assets/img/device_cf.png';
import stickup_cam_mini_ptz_v1, { default as stickup_cam_mini } from '$src/assets/img/device_indoor_cam.png';
import doorbell_portal from '$src/assets/img/device_door_view_cam.png';
import doorbell_scallop_lite, { default as doorbell_scallop } from '$src/assets/img/device_doorbell_3.png';
import doorbell_oyster from '$src/assets/img/device_doorbell_4.png';
import stickup_cam, { default as stickup_cam_v3 } from '$src/assets/img/device_stick_up_cam_battery.png';
import stickup_cam_lunar from '$src/assets/img/device_stick_up_cam_battery_gen_2.png';
import stickup_cam_medusa from '$src/assets/img/device_stick_up_cam_pro.png';
import stickup_cam_v4 from '$src/assets/img/device_spotlight_cam_solar.png';
import stickup_cam_longfin from '$src/assets/img/device_stickup_cam_longfin.png';
import lpd_v1, { default as lpd_v2, default as lpd_v3 } from '$src/assets/img/device_doorbell_pro.png';
import lpd_v4 from '$src/assets/img/device_doorbell_pro_gen_2.png';
import jbox_v1 from '$src/assets/img/device_doorbell_elite.png';
import stickup_cam_wired, { default as stickup_cam_elite } from '$src/assets/img/device_stick_up_cam_wired.png';
import hp_cam_v1, { default as floodlight_v2 } from '$src/assets/img/device_floodlight_cam.png';
import floodlight_pro from '$src/assets/img/device_floodlight_cam_wired_pro.png';
import hp_cam_v2, { default as spotlightw_v2 } from '$src/assets/img/device_spotlight_cam_wired.png';
import cocoa_doorbell, { default as cocoa_doorbell_v2, default as cocoa_doorbell_v3 } from '$src/assets/img/device_nf.png';
import cocoa_doorbell_v4w from '$src/assets/img/cocoa_doorbell_v4w.png';
import cocoa_doorbell_v5 from '$src/assets/img/cocoa_doorbell_v5.png';
import cocoa_doorbell_v5_ac from '$src/assets/img/cocoa_doorbell_v5_ac.png';
import cocoa_doorbell_v6 from '$src/assets/img/cocoa_doorbell_v6.png';
import cocoa_doorbell_v4 from '$src/assets/img/cocoa_doorbell_v4.png';
import doorbell_tahoe from '$src/assets/img/doorbell_tahoe.png';
import doorbell_sunray from '$src/assets/img/doorbell_sunray.png';
import osprey_floodlight from '$src/assets/img/osprey_floodlight.png';
import lionfish_spotlight from '$src/assets/img/lionfish_spotlight.png';
import chromis_stickup from '$src/assets/img/chromis_stickup.png';
import coralfish_camera from '$src/assets/img/coralfish_camera.png';
import moray_camera from '$src/assets/img/moray_camera.png';
import opaleye_spotlight from '$src/assets/img/opaleye_spotlight.png';
import jewelfish_camera from '$src/assets/img/jewelfish_camera.png';
import pencilfish_camera from '$src/assets/img/pencilfish_camera.png';
import snapper_floodlight from '$src/assets/img/snapper_floodlight.png';
import cocoa_camera from '$src/assets/img/device_stick_up_cam_battery_3.png';
import cocoa_camera_v2 from '$src/assets/img/device_outdoor_cam_plus.jpg';
import cocoa_camera_v3 from '$src/assets/img/cocoa_camera_v3.png';
import cocoa_floodlight from '$src/assets/img/device_floodlight_cam_wired_plus.png';
import cocoa_floodlight_v2 from '$src/assets/img/cocoa_floodlight_v2.png';
import cocoa_spotlight from '$src/assets/img/device_spotlight_cam_plus.png';
import cocoa_spotlight_v2 from '$src/assets/img/cocoa_spotlight_v2.png';
import stickup_cam_mini_v2 from '$src/assets/img/device_indoor_cam_2.png';
import stickup_cam_mini_v3 from '$src/assets/img/stickup_cam_mini_v3.png';
import base_station_k1 from '$src/assets/img/device_alarm_pro_base_station.png';
import base_station_v1 from '$src/assets/img/device_alarm_base_station.png';
import rccs_1p_jaws from '$src/assets/img/device_mobility_car_cam.png';
import vehicle_brody_v1 from '$src/assets/img/device_mobility_car_alarm.png';
import astro from '$src/assets/img/device_astro.jpg';
import onvif_camera from '$src/assets/img/device_onvif.png';
import doorbot from '$src/assets/img/device_doorbell_gen_2.png';
import stickup_cam_gourami from '$src/assets/img/device_stick_up_cam_plug-in_v2.png';
import always_home_camera, { default as always_home_camera_v2 } from '$src/assets/img/device_always_home_cam.png';
import hexa_camera from '$src/assets/img/device_hexa.png';
import ring_logo from '$src/assets/img/ring_logo.png';

const DEVICE_IMG_MATCH = Object.freeze({
  doorbell_graham_cracker,
  doorbell,
  doorbell_v2,
  doorbell_v3,
  doorbell_v4,
  doorbell_v5,
  df_doorbell_clownfish,
  stickup_cam_mini_ptz_v1,
  doorbell_portal,
  doorbell_scallop_lite,
  doorbell_scallop,
  doorbell_oyster,
  stickup_cam,
  stickup_cam_v3,
  stickup_cam_lunar,
  stickup_cam_medusa,
  stickup_cam_v4,
  stickup_cam_longfin,
  lpd_v1,
  lpd_v3,
  lpd_v2,
  lpd_v4,
  jbox_v1,
  stickup_cam_mini,
  stickup_cam_wired,
  stickup_cam_elite,
  hp_cam_v1,
  floodlight_v2,
  floodlight_pro,
  hp_cam_v2,
  spotlightw_v2,
  cocoa_doorbell,
  cocoa_doorbell_v2,
  cocoa_doorbell_v3,
  cocoa_doorbell_v4w,
  cocoa_doorbell_v5,
  cocoa_doorbell_v5_ac,
  cocoa_doorbell_v6,
  cocoa_doorbell_v4,
  doorbell_tahoe,
  doorbell_sunray,
  osprey_floodlight,
  lionfish_spotlight,
  chromis_stickup,
  coralfish_camera,
  moray_camera,
  opaleye_spotlight,
  jewelfish_camera,
  pencilfish_camera,
  snapper_floodlight,
  cocoa_camera,
  cocoa_camera_v2,
  cocoa_camera_v3,
  cocoa_floodlight,
  cocoa_floodlight_v2,
  cocoa_spotlight,
  cocoa_spotlight_v2,
  stickup_cam_mini_v2,
  stickup_cam_mini_v3,
  base_station_k1,
  base_station_v1,
  rccs_1p_jaws,
  vehicle_brody_v1,
  astro,
  onvif_camera,
  doorbot,
  stickup_cam_gourami,
  always_home_camera,
  always_home_camera_v2,
  hexa_camera,
  ring_logo
});

function selectIcon(deviceType) {
  const defaultIcon = DEVICE_IMG_MATCH.ring_logo;
  if (DEVICE_IMG_MATCH[deviceType]) {
    return DEVICE_IMG_MATCH[deviceType];
  }
  // Match the whole Hexa (Perch) family by prefix so new lens-count variants
  // (e.g. hexa_camera_6_v1) resolve to the Hexa image instead of the logo.
  if (typeof deviceType === 'string' && deviceType.startsWith('hexa_camera')) {
    return DEVICE_IMG_MATCH.hexa_camera;
  }
  return defaultIcon;
}

export default selectIcon;
